import { FC } from "react";
import { Tabs } from "@rothoblaas/design-system";
import useI18n from "../../../../hooks/useTranslations";
import AdminConnectorFamilies from "./AdminConnectorFamilies";
import AdminConnectorMappings from "./AdminConnectorMappings";
import AdminConnectorMaterials from "./AdminConnectorMaterials";
import AdminConnectors from "./AdminConnectors";

const AdminConnectorsTabs: FC = () => {
  const i18n = useI18n();

  return (
    <Tabs.SubTab>
      <Tabs
        urlParameter="connectors_tab"
        tabs={[
          { title: i18n.translation.deckDesignerModule.connectors.plural },
          { title: i18n.translation.deckDesignerModule.connectorFamilies.plural },
          { title: i18n.translation.deckDesignerModule.connectorMappings.plural },
          { title: i18n.translation.deckDesignerModule.connectorMaterials.plural },
        ]}
        contents={[
          <AdminConnectors />,
          <AdminConnectorFamilies />,
          <AdminConnectorMappings />,
          <AdminConnectorMaterials />,
        ]}
      />
    </Tabs.SubTab>
  );
};

export default AdminConnectorsTabs;
